import React from 'react'
import styles from './NetPoints.less'
import blockUrl from './images/block.png'
import {promisifyLoadImg} from '../../../../../../../util'

class NetPoints extends React.Component {
	constructor (props) {
		super(props)
		this.canvasRef = React.createRef();
		this.wrapperRef = React.createRef();
		this.infoRef = React.createRef();
		this.getLangMsg = props.getLangMsg
		this.ctx = null
		this.posList = []
		this.lineList = []
		this.styleObj = {}
		this.infoStyle = {}
		this.handleClick = this.handleClick.bind(this)
		this.transformToRgb = this.transformToRgb.bind(this)

		this.state = {
			currentInfo: {},
			width: 600,
			height: 600,
			R: 0
		}
	}

	// 计算两点之间的距离
	calDistance (x,y) { 
		return Math.sqrt(x*x + y*y)
		// return Math.max(Math.abs(x), Math.abs(y))
	}

	// 获取随机角度和半径的坐标点
	// getRandomRadiusAndAngle (n) { 
	// 	const radius = Math.random() * this.state.R //todo:考虑distanceRange以外半径
	// 	let angle = (0.5 * n + Math.random() * 0.5) * Math.PI;

	// 	return {
	// 		x: Math.round(radius*Math.cos(angle)),
	// 		y: Math.round(-radius*Math.sin(angle))
	// 	}
	// }

	// 获取符合规范的坐标点
	// getPoint () { 
	// 	const distanceRange = 80
	// 	const MIN = 99999
	// 	let min = MIN
	// 	const n = this.posList.length % 4
	// 	let { x, y } = this.getRandomRadiusAndAngle(n)
	// 	let distance = 0

	// 	while (distance < distanceRange) {
	// 		for (let { x: x1, y: y1 } of this.posList) {
	// 			distance = this.calDistance(x1 - x, y1 - y)
	// 			if (distance < distanceRange) { 
	// 				const pos = this.getRandomRadiusAndAngle(n)
	// 				x = pos.x
	// 				y = pos.y
	// 				min = MIN
	// 				break
	// 			}

	// 			min = Math.min(distance, min)          
	// 		}
	// 	}

	// 	return {x, y}
  // }

	// getPoint2(n) { 
	// 	const points = [];
	// 	const phi = Math.PI * (3 - Math.sqrt(5));

	// 	for (let i = 0; i < n; i++) { 
	// 		const y = 1 - (i / (n - 1)) * 2;
	// 		const radius = Math.sqrt(1 - y * y) * this.state.R;
	// 		const theta = phi * i;
	// 		const x = Math.round(Math.cos(theta) * radius);

	// 		points.push({ x, y: Math.round(y * this.state.R) });
	// 	}
	// 	console.log('points', points);
	// 	return points;
	// }

	getPoint3(n) { 
		// gen_fib_lattice
		const phi = (1 + Math.sqrt(5)) / 2;
		const tmpArr = Array(n).fill().map((_, i) => i + 1);
		const x = tmpArr.map(item => (item / phi) % 1);
		const y = tmpArr.map(item => item / n);

		// area_preserve_rec2circ
		const theta = x.map(item => 2 * Math.PI * item);
		const r = y.map(item => Math.sqrt(item));

		// area_preserve_circ2sphere
		const phiArr = r.map(item => 2 * Math.asin(item));
		return theta.map((item, i) => ({ x:  Math.round(Math.cos(item) * Math.sin(phiArr[i]) * this.state.R), y:  Math.round(Math.sin(item) * Math.sin(phiArr[i]) * this.state.R) }));
	}
  
  //判断两条线段是否相交 
	checkCross ( a1, a2, b1, b2 ) {
		var ua_t = (b2.x - b1.x) * (a1.y - b1.y) - (b2.y - b1.y) * (a1.x - b1.x);
		var ub_t = (a2.x - a1.x) * (a1.y - b1.y) - (a2.y - a1.y) * (a1.x - b1.x);
		var u_b = (b2.y - b1.y) * (a2.x - a1.x) - (b2.x - b1.x) * (a2.y - a1.y);
		if ( u_b !== 0 ) {
		var ua = ua_t / u_b;
		var ub = ub_t / u_b;
		if ( 0 <= ua && ua <= 1 && 0 <= ub && ub <= 1 ) {
		return true;
		}
		}
		return false;
	 }

	 //判断两条线段是否连接,这种情况要排除在相交外！
	isSamePoint (line1, line2) { 
		return line1.from === line2.from || line1.from === line2.to || line1.to === line2.from || line1.to === line2.to
  }
  
  //画图
	async drawGraphics(n) { 
		try {
			const img = await promisifyLoadImg(blockUrl, 60, 57)
			this.ctx.clearRect(0, 0, this.state.width, this.state.height)
			this.ctx.translate(this.state.width / 2, this.state.height / 2);

      this.ctx.beginPath()
			      
			this.posList = this.getPoint3(n);

			for (let i = 0; i < this.posList.length-1; i++) { 
				for (let j = i + 1; j < this.posList.length; j++) { 
					this.lineList.push({
						from: this.posList[i],
						to: this.posList[j],
						len: this.calDistance(this.posList[i].x - this.posList[j].x, this.posList[i].y - this.posList[j].y)
					})
				}
			}

			this.lineList = this.lineList.sort((item1, item2) => item2.len - item1.len)

			for (let i = 0; i < this.lineList.length-1; i++) {
				for (let j = i + 1; j < this.lineList.length; j++) {
					if (this.isSamePoint(this.lineList[i], this.lineList[j])) { 
						continue;
					}
					if (this.checkCross(this.lineList[i].from, this.lineList[i].to, this.lineList[j].from, this.lineList[j].to)) { 
						this.lineList.splice(i, 1)
						i--
						break;
					}
				}
			}

			this.ctx.strokeStyle = 'rgb(214,214,214)';
			for (let i = 0; i < this.lineList.length; i++) {
					this.ctx.moveTo(this.lineList[i].from.x, this.lineList[i].from.y)
					this.ctx.lineTo(this.lineList[i].to.x, this.lineList[i].to.y)
					this.ctx.stroke()          
			}
						
			for (let i = 0; i < n; i++) {
				this.ctx.drawImage(img, this.posList[i].x - 30, this.posList[i].y - 28, 60, 57)
			}

			this.ctx.translate(-this.state.width / 2, -this.state.height / 2);
		} catch (error) {
			console.log(error);
		}
  }
  
  isWithin (num1, num2) {
		return num1 >= num2-30 && num1 <= num2+30
	}

	calStyleOgj({x, y}) {
		const W = 380;
		const H = 148;
		if (this.state.width/2 - x > W) {
			return {
				left: `${this.state.width/2 + x + 40}px`,
				bottom: `${Math.max(20, this.state.height - Math.max(y+this.state.height/2, 180))}px`
			}
		} else {
			return {
				right: `${this.state.width/2 + x + 40}px`,
				bottom: `${Math.max(20, this.state.height - Math.max(y+this.state.height/2, 180))}px`
			}
		}
	}

	handleClick (e) {
		const { offsetX, offsetY, layerX, layerY } = e
		this.styleObj = {
			display: 'none'
		}
		this.setState({
			currentInfo: {}
		})		
    for (let i = 0; i < this.posList.length; i++) { 
      const trgX = (offsetX || layerX) - this.state.width / 2 // layerX/Y is for firefox
			const trgY = (offsetY || layerY) - this.state.height / 2
      if (this.isWithin(trgX, this.posList[i].x) && this.isWithin(trgY, this.posList[i].y)) { 
				
				this.styleObj = {
					display: 'block',
					left: `${this.posList[i].x + this.state.width / 2 - 30}px`,
					top: `${this.posList[i].y + this.state.height / 2- 30}px`
				}
        this.infoStyle = this.calStyleOgj(this.posList[i])
				this.setState({
					currentInfo: this.props.customProps[i]
				})
        break
			}			
    }
  }
  
  transformToRgb (addr) {
		// addr:2 6*6 2
		const start = addr.slice(0, 2);
		const end = addr.slice(38);
		const main = addr.slice(2, 38);

		let p = '';
		p += start

		for(let i = 0; i < main.length; i++) {
			p += `<span style="background: #${main.slice(i,i+6)}; width: 12px; height: 12px; border: 1px solid #fff; border-radius: 1px; display: inline-block;"></span>`
			i = i + 5;
		}
		p += end

		return p;
  }
  
  formatText(key) {
    const statusMap = {
      Granted: this.getLangMsg('nodes.key0018'),
      Forbidden: this.getLangMsg('nodes.key0019'),
      Disable: this.getLangMsg('nodes.key0020'),
      Applying: this.getLangMsg('nodes.key0021')
    }
    return key === 'status' ? statusMap[this.state.currentInfo[key]] : this.state.currentInfo[key]
  }

	componentDidUpdate(prevProps) {
    if (prevProps.networkKey !== this.props.networkKey ) {
			console.log('---------------updating------------');
      this.drawGraphics(this.props.customProps.length)
    }    
  }
  
	async componentDidMount() {
		const canvas = this.canvasRef.current;
		if (!canvas.getContext) return;
		this.ctx = canvas.getContext("2d");

		const { width, height } = this.wrapperRef.current.getBoundingClientRect();
		const ratio = 2;
		canvas.style.width = `${width}px`;
		canvas.style.height = `${height}px`;
		canvas.width = width * ratio;
		canvas.height = height * ratio;
		this.ctx.scale(ratio, ratio);

		this.setState({
			width,
			height,
			R: (Math.min(width, height) - 60)  / 2
    })

		
    // await this.drawGraphics(20) //本地无数据测试用，可删！！！
    
		document.addEventListener('click', this.handleClick)    
  }

	componentWillUnmount() {
		document.removeEventListener('click', this.handleClick)
  }
  
	render() {
		const keyMap = {
			serviceName: this.getLangMsg('nodes.key0014'),
			company: this.getLangMsg('nodes.key0015'),
			bduId: this.getLangMsg('nodes.key0016'),
			status: this.getLangMsg('nodes.key0017')
		}
    console.log('rendering canvas...', this.props.customProps.length)
		return (
      <div className={styles['points-ctn']} ref={this.wrapperRef}>
        <div className={styles['canvas-ctn']}>
        <p className={styles['top-title']}>{this.getLangMsg('nodes.key0011')}</p>
					<canvas ref={this.canvasRef}>
						您的浏览器不支持canvas，请更换浏览器。
					</canvas>
					<img src={blockUrl} className={styles['img-hover']} style={this.styleObj}></img>

					{
        this.state.currentInfo && this.state.currentInfo.bduId ? (
        <div className={styles['info-ctn']} style={this.infoStyle}>
          <p className={styles['info-title']}>{this.getLangMsg('nodes.key0012')}</p>
					<ul>
						{
							Object.entries(keyMap).map(([key, val], idx) => (
								<li key={idx} className={styles['info-item']}>
									<span className={styles['info-item-key']}>{val}:</span>									
									{
                    key === 'bduId'
                      ?
                      <p dangerouslySetInnerHTML={{ __html: this.transformToRgb(this.state.currentInfo.bduId) }} className={styles['ip_addr_ctn']} title={ this.state.currentInfo.bduId}></p>
                      :
                      <span>{this.formatText(key)}</span>
									}									
									
								</li>
							))
						}
					</ul>
        </div>
        ) : null
      }
				</div>				
					
		</div>
		)		 
	}
}

export default NetPoints